import events from "@/events";

let config;

const isGuest = () => {
  if (!config) {
    return true;
  }
  return config.guest;
};

const isLoggedIn = () => {
  return !isGuest();
};

events.on("setup:ready", data => {
  config = data;
});

export default {
  isGuest,
  isLoggedIn
};
